"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var border = function (color) { return "border: 1px solid " + color + ";"; };
exports.default = (function (_a) {
    var warning = _a.warning, success = _a.success, error = _a.error;
    return function (_a) {
        var theme = _a.theme;
        if (warning) {
            return border(theme.palette.bannerBorder[1]);
        }
        if (success) {
            return border(theme.palette.bannerBorder[2]);
        }
        if (error) {
            return border(theme.palette.bannerBorder[3]);
        }
        return border(theme.palette.bannerBorder[0]);
    };
});
